import React from 'react'
import { ApiTableSkeleton, BarChartSkeleton } from '@e3dc-react/shell/Elements/Skeletons'
import { Stack, Skeleton, Divider, Paper, Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  divider: {
    borderColor: theme.palette.divider,
  },
  cardStats: {
    marginTop: theme.spacing(2),
  },
  cardSkeleton: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
  },
  filterSkeleton: {
    borderRadius: theme.spacing(theme.shape.borderRadius),
    height: 36,
    width: 100,
  },
  tableContainer: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
}))

const ChargingSessionsOverviewSkeleton = (): JSX.Element => {
  const { classes, cx } = useStyles()
  return (
    <Box>
      <Stack direction="row" spacing={2} mt={4} mb={2}>
        <Skeleton variant="rounded" className={cx(classes.cardSkeleton, classes.filterSkeleton)} />
        <Skeleton variant="rounded" className={cx(classes.cardSkeleton, classes.filterSkeleton)} />
        <Skeleton variant="rounded" className={cx(classes.cardSkeleton, classes.filterSkeleton)} />
      </Stack>

      <Divider className={classes.divider} />

      <Stack direction="row" rowGap={2} columnGap={2} className={classes.cardStats} flexWrap="wrap">
        <Skeleton variant="rounded" height={90} width={200} className={classes.cardSkeleton} />
        <Skeleton variant="rounded" height={90} width={200} className={classes.cardSkeleton} />
        <Skeleton variant="rounded" height={90} width={200} className={classes.cardSkeleton} />
      </Stack>

      <Box className={classes.tableContainer}>
        <Paper>
          <ApiTableSkeleton columnAmount={5} withFilter={false} />
        </Paper>
      </Box>

      <Paper sx={{ mt: 4 }}>
        <BarChartSkeleton height={400} />
      </Paper>
    </Box>
  )
}

export default ChargingSessionsOverviewSkeleton
